// Core imports
import { Fragment, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import OauthPopup from 'react-oauth-popup';

// Component imports
import { Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useOidcRequest } from '../../utils/hooks/useOidcRequest';
import { NAV_OIDC_CALLBACK } from '../../constants/navigation';

const OIDC_OPTIONS = {
  /*
   * Any endpoint that will NOT redirect and will NOT try to complete the authorization will do.
   * It is just to get the configuration from the issuer.
   */
  redirectUri: `${window.location.origin}${NAV_OIDC_CALLBACK}`
};

const OidcLoginButton = ({
  integration,
  organizationId,
  onSuccess,
  buttonContent
}) => {
  const [oidcIsLoading, setOidcIsLoading] = useState(false);
  const oidcButtonRef = useRef(null);

  const { oidcRedirectUrl, oidcAuthorizationUrl, oidcCodeVerifier, oidcVariables } = useOidcRequest({ integration, organizationId, options: OIDC_OPTIONS });

  const onCode = useCallback((code, params) => {
    const tokenBody = {
      code,
      integrationId: integration?.id,
      organizationId,
      redirectUri: oidcRedirectUrl,
      codeVerifier: oidcCodeVerifier
    };
    if (oidcVariables) {
      tokenBody.variables = oidcVariables;
    }

    setOidcIsLoading(false);
    onSuccess?.(tokenBody);
  }, [onSuccess, oidcCodeVerifier, oidcRedirectUrl]);

  const onClose = () => {
    setOidcIsLoading(false);
  };

  return (
    <Fragment>
      <OauthPopup
        url={oidcAuthorizationUrl}
        onCode={onCode}
        onClose={onClose}
        width={700}
        height={650}
      >
        <Button
          ref={oidcButtonRef}
          size="large"
          block
          className="mb-3"
          loading={oidcIsLoading}
          icon={<LockOutlined className="mr-3" />}
          onClick={() => setOidcIsLoading(true)}
        >
          {buttonContent}
        </Button>
      </OauthPopup>
    </Fragment>
  );
};

OidcLoginButton.propTypes = {
  integration: PropTypes.object.isRequired,
  organizationId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  buttonContent: PropTypes.string.isRequired
};

export default OidcLoginButton;
